module.exports = __webpack_public_path__ + "8cfeeea233ce30c3a7d0ce29282ea41d.MP3";